import React, { useState } from 'react';
import styles from './ArquivosPopup.module.css';
import { 
    FaTimes, FaFolder, FaMapMarkedAlt, FaFileContract, 
    FaFileInvoice, FaImages, FaVideo, FaFileAlt 
} from 'react-icons/fa';

import FolderContentPopup from './FolderContentPopup'; 

const ArquivosPopup = ({ isOpen, onClose, imovelId }) => {
    const [activeFolder, setActiveFolder] = useState(null);

    if (!isOpen) {
        return null;
    }

    const folders = [
        { name: 'Mapas', icon: <FaMapMarkedAlt className={styles.folderIcon} /> },
        { name: 'Contratos', icon: <FaFileContract className={styles.folderIcon} /> },
        { name: 'Escrituras', icon: <FaFileInvoice className={styles.folderIcon} /> },
        { name: 'Fotos', icon: <FaImages className={styles.folderIcon} /> },
        { name: 'Vídeos', icon: <FaVideo className={styles.folderIcon} /> },
        { name: 'CAR', icon: <FaFileAlt className={styles.folderIcon} /> },
        { name: 'CCIR', icon: <FaFileAlt className={styles.folderIcon} /> },
        { name: 'ITR', icon: <FaFileAlt className={styles.folderIcon} /> },
    ];

    const handleContentClick = (e) => e.stopPropagation();
    
    const handleFolderClick = (folder) => setActiveFolder(folder);
    const handleCloseFolderContent = () => setActiveFolder(null);

    return (
        <>
            <div className={styles.modalOverlay} onClick={onClose}>
                <div className={styles.modalContent} onClick={handleContentClick}>
                    <div className={styles.modalHeader}>
                        <h2 className={styles.modalTitle}>
                            <FaFolder /> Arquivos do Imóvel
                        </h2>
                        <button onClick={onClose} className={styles.closeButton}>
                            <FaTimes />
                        </button>
                    </div>
                    <div className={styles.folderGrid}>
                        {folders.map((folder, index) => (
                            <div key={index} className={styles.folderItem} onClick={() => handleFolderClick(folder)}>
                                {folder.icon}
                                <span className={styles.folderName}>{folder.name}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {activeFolder && (
                <FolderContentPopup
                    isOpen={!!activeFolder}
                    onClose={handleCloseFolderContent}
                    folderName={activeFolder.name}
                    folderIcon={activeFolder.icon}
                    imovelId={imovelId}
                />
            )}
        </>
    );
};

export default ArquivosPopup;